let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dP03a")).then(() => parcelRequire('kcBMK'));